<template>
  <div class="admin-copies">
    <navbar></navbar>
    <h2>Admin Copies ({{copies.length}})</h2>
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th>Text</th>
          <th>Location</th>
          <th>Signature</th>
          <th>#UT</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="copy in copies">
          <td>{{copy.Text}}</td>
          <td>{{copy.Location}}</td>
          <td>{{copy.Signature}}</td>
          <td>{{copy.NumberOfUserstraces}}</td>
          <td><b-button v-on:click="open(copy.Id)">Edit</b-button></td>
        </tr>
      </tbody>
    </table>

    <b-button v-on:click="newcopy()">Add</b-button>
  </div>
</template>

<script>

import navbar from '@/components/navbar.vue';

export default {
  name: 'admin-copies',
  data () {
    return {
      copies : []
    }
  },
  methods: {
    // Load employee-data form webserivce
    loaddata: function () {
      this.$http.post('pCopyList').then(function(response) { this.copies = response.data; });
    },
    open: function (id) {
      this.$router.push({ name: "AdminCopy", params: { id: id }});
    },
    newcopy: function() {
      this.$router.push({ name: "AdminNewCopy" });
    }
  },
  components: {
    'navbar': navbar
  },
  created: function() {
					this.loaddata();
        }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// admin-copies.vue?19ff4664